module.exports = __webpack_public_path__ + "img/brinquedos.f0f3315b.png";